// extracted by mini-css-extract-plugin
export default {"root":"_1aawj","cardsContainer":"AezSA","caption":"UnELx","skeleton-progress":"HdChl"};